var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.328 1.215-.243 1.725c-4.317.3-8.316 2.737-7.471 7.309.087.473.493.684.946.554 4.699-1.8 10.004-1.836 14.527-.109.605.163 1.275-.183 1.358-.817.564-4.31-3.292-6.621-7.467-6.933l-.244-1.729c-.08-.287-1.326-.287-1.406 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.986 21.987c-1.682 1.35-2.293 1.35-3.974 0 0 0-6.969-1.269-4.938-10.213 3.506-1.58 10.357-1.635 13.85 0 2.038 8.671-4.938 10.213-4.938 10.213Zm2.523-3.64c-.28.405-.776.081-.664-.398.402-1.733.473-3.692-.234-5.528.778.108 1.205.206 1.935.509.247 1.693.048 3.848-1.037 5.418Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResos);
export default __webpack_public_path__ + "static/media/resos.c266e582f7873515df2ac57ed5ef20b9.svg";
export { ForwardRef as ReactComponent };